import React, {Component} from 'react';
import classNames from 'classnames';
import Mailcheck from 'mailcheck';
import FormElementError from '@spothero/ui/form-element-error';
import isNil from 'lodash/isNil';
import TextInput from '@spothero/ui/text-input';
import TextInputPropTypes from '@spothero/ui/text-input-prop-types';
import Label from '@spothero/ui/label';
import ValidationUtils from '@spothero/utils/validation';

class EmailControl extends Component {
    static propTypes = TextInputPropTypes;

    state = {
        suggestion: null,
        pendingSuggestion: null,
    };
    inputRef = React.createRef();

    componentDidMount() {
        this.inputRef.current.node.addEventListener(
            'keyup',
            this._onInputKeyUp
        );
    }

    componentWillUnmount() {
        this.inputRef.current.node.removeEventListener(
            'keyup',
            this._onInputKeyUp
        );
    }

    _onInputKeyUp = evt => {
        if (evt.which === 13) {
            this._promote();
        }
    };

    _onInputBlur = evt => {
        const {onBlur} = this.props;

        this._promote();

        if (onBlur) {
            onBlur(evt);
        }
    };

    _onInputChange = evt => {
        const {onChange} = this.props;
        const {currentTarget: target} = evt;
        let suggestion = null;

        if (target.validity.valid) {
            const email = target.value;
            const result = Mailcheck.run({email});

            if (result) {
                suggestion = result.full;
            }
        }

        this.setState({pendingSuggestion: suggestion});

        if (onChange) {
            onChange({...evt, suggestion});
        }
    };

    _onSuggestionClick = () => {
        const input = this.inputRef.current.node;

        input.value = this.state.suggestion;
        input.focus();
        this.setState({
            suggestion: null,
            pendingSuggestion: null,
        });
    };

    _promote() {
        this.setState(({pendingSuggestion}) => ({
            suggestion: pendingSuggestion,
        }));
    }

    _renderSuggestion() {
        const {helpNode} = this.props;
        const {suggestion} = this.state;

        if (isNil(suggestion)) {
            return helpNode;
        }

        const email = (
            <a
                className="EmailControl-suggestion"
                onClick={this._onSuggestionClick}
            >
                {suggestion}
            </a>
        );

        return <span>Did you mean {email}?</span>;
    }

    render() {
        const classes = classNames('EmailControl', this.props.className);

        return (
            <TextInput
                {...this.props}
                ref={this.inputRef}
                className={classes}
                type="email"
                name="email"
                label={<Label>Email</Label>}
                pattern={ValidationUtils.EMAIL}
                error={
                    <FormElementError>
                        Please enter a valid email.
                    </FormElementError>
                }
                helpNode={this._renderSuggestion()}
                onChange={this._onInputChange}
                onBlur={this._onInputBlur}
            />
        );
    }
}

export default EmailControl;
